const config = {
  baseUrl: 'https://www.dongjiangyc.com/api',
  h5Appid: 'wxf6d2115aedde70b5',
  debug: false,
  OSS_PROVIDER: 'qcloud',
  qrcodeUrl: 'https://www.dongjiangyc.com/',
  version: '100'
}
module.exports = config